
<template>
   {{myString}}
</template>

<script>
import { ref } from "vue";

export default {
  props: {
    produkte:{type:Object},
  },
  setup(props) {
    let myString=ref("")
    props.produkte.forEach(function(produkt){
      myString.value += produkt.menge +" x "+produkt.name
    })

    return {
      myString,
    };
  },        
};
</script>





